import { useMutation } from '@tanstack/react-query';
import { withdrawalReportService } from 'commons/services/withdrawalReportService';

interface UseCreateWithdrawalReportMutationProps {
  onSuccess: (requestId: number) => void;
  onError?: () => void;
}

export function useCreateWithdrawalReportMutation({
  onSuccess,
  onError,
}: UseCreateWithdrawalReportMutationProps) {
  return useMutation(
    (withdrawalId: number) =>
      withdrawalReportService.createWithdrawalReport(withdrawalId),
    {
      onSuccess: (data) => {
        onSuccess(data.requestId);
      },
      onError: () => {
        onError?.();
      },
    },
  );
}
